import headerLogo from './NewImages/logo.png'
import  register from './NewImages/sign_up_banner.png'
import  appstore from './NewImages/appstore.png'
import  googleplay from './NewImages/googleplay.png'
import  loginimg from './NewImages/loginimg.png'
import warningimg from './NewImages/warning.png'


const NewImage = {
    headerLogo,
    register,
    appstore,
    googleplay,
    loginimg,
    warningimg
};

export default NewImage;
